<ng-template [ngIf]="item.value !== null"
             [ngIfElse]="group">
    <div class="value"
         (click)="onClick(item.value)">
        {{ item.value[labelKey] }}
    </div>
</ng-template>
<ng-template #group>
    <div class="group unclickable">
        {{ item.key }}
    </div>
</ng-template>
